import { useEffect, useState } from "react";
import { useStockMarketCap } from "../../context/StockMarketCapContext";
import { useStockDaily } from "../../context/StockDailyContext";
import localforage from "localforage";

function MarketCap() {
  const {
    marketCapStore,
    fetchNasdaqMarketCap,
    loading,
    total,
    loadedCount,
    error,
  } = useStockMarketCap();
  const { dailyStore, fetchNasdaq100Daily, loadedCount1, total1 } =
    useStockDaily();
  const [sortOrder, setSortOrder] = useState("high");
  const sortedData = [...Object.values(marketCapStore)].sort((a, b) => {
    const capA = Number(a.marketCap) || 0;
    const capB = Number(b.marketCap) || 0;

    return sortOrder === "high" ? capB - capA : capA - capB;
  });

  useEffect(() => {
    fetchNasdaqMarketCap();
    fetchNasdaq100Daily();
  }, [fetchNasdaqMarketCap, fetchNasdaq100Daily]);

  const mergedData = Object.keys(dailyStore).map((symbol) => ({
    symbol,
    ...dailyStore[symbol]?.latest,
    marketCap: Number(marketCapStore?.[symbol]?.marketCap || 0),
  }));
  console.log("merged data", mergedData);
  useEffect(() => {
    if (!mergedData.length) return;

    const saveMergedData = async () => {
      try {
        await localforage.setItem("mergedStockData", {
          data: mergedData,
          timestamp: Date.now(),
        });

        console.log("✅ Merged data saved to localforage");
      } catch (err) {
        console.error("❌ Failed to save merged data:", err);
      }
    };

    saveMergedData();
  }, [mergedData]);

  if (loading) {
    return (
      <p>
        Loading Market Cap Data {loadedCount}/{total}...
        <p>
          LOADING Daily Stock {loadedCount1}/{total1}...
        </p>
      </p>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>
      {/* <div style={{ marginBottom: "12px" }}>
        <label style={{ marginRight: "10px", fontWeight: "600" }}>
          Sort by:
        </label>

        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option value="high">Market Cap: High → Low</option>
          <option value="low">Market Cap: Low → High</option>
        </select>
      </div> */}

      {mergedData.length === 0 ? (
        <p>Loading data...</p>
      ) : (
        mergedData.map((item) => (
          <div key={item.symbol}>
            <strong>{item.symbol}</strong> | % Change:{" "}
            <strong>{item.percentChange ?? "N/A"}%</strong> | Market Cap:{" "}
            {item.marketCap !== 0 ? item.marketCap.toLocaleString() : "N/A"}
          </div>
        ))
      )}
    </>
  );
}

export default MarketCap;
